import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";

import { toastInititalState } from "./actions";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = (props) => {
  const { t } = props;
  const dispatch = useDispatch();

  const {
    activeSuccess,
    successMessage,
    activeWarning,
    warningMessage,
    activeError,
    errorMessage,
  } = useSelector((state) => state.toastsReducer);

  useEffect(() => {
    if (activeSuccess) {
      toast.success("✔️ " + t(successMessage), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    dispatch(toastInititalState());
  }, [activeSuccess]);

  useEffect(() => {
    if (activeWarning) {
      toast.warning("⚠️ " + t(warningMessage), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    dispatch(toastInititalState());
  }, [activeWarning]);

  useEffect(() => {
    if (activeError) {
      toast.error("❌ " + t(errorMessage), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    dispatch(toastInititalState());
  }, [dispatch, activeError]);

  return <ToastContainer />;
};

export default withNamespaces()(Toast);
